"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopSessionFilters = void 0;
const react_1 = __importDefault(require("react"));
const filters_1 = require("../../../types/filters");
const sensors_1 = require("../../../types/sensors");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const CrowdmapToggle_1 = require("./CrowdmapToggle");
const DormantToggle_1 = require("./DormantToggle");
const IndoorOutdoorSwitch_1 = require("./IndoorOutdoorSwitch");
const ParameterFilter_1 = require("./ParameterFilter");
const ProfileNamesInput_1 = require("./ProfileNamesInput");
const SensorFilter_1 = require("./SensorFilter");
const S = __importStar(require("./SessionFilters.style"));
const SessionTypeToggle_1 = require("./SessionTypeToggle");
const TagsInput_1 = require("./TagsInput");
const YearPicker_1 = require("./YearPicker");
const DesktopSessionFilters = () => {
    const { sessionType, sensorName } = (0, mapParamsHandler_1.useMapParams)();
    const fixedSessionTypeSelected = sessionType === filters_1.SessionTypes.FIXED;
    const airBeamSensorNameSelected = sensorName.startsWith(sensors_1.SensorPrefix.AIR);
    const govermentSensorNameSelected = sensorName.startsWith(sensors_1.SensorPrefix.GOVERNMENT);
    return (react_1.default.createElement(S.SessionFilters, null,
        react_1.default.createElement(SessionTypeToggle_1.SessionTypeToggle, null),
        react_1.default.createElement(ParameterFilter_1.DesktopParameterFilter, null),
        react_1.default.createElement(SensorFilter_1.DesktopSensorFilter, null),
        !govermentSensorNameSelected && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ProfileNamesInput_1.ProfileNamesInput, null),
            react_1.default.createElement(TagsInput_1.TagsInput, null))),
        fixedSessionTypeSelected && airBeamSensorNameSelected && (react_1.default.createElement(IndoorOutdoorSwitch_1.IndoorOutdoorSwitch, null)),
        fixedSessionTypeSelected && react_1.default.createElement(DormantToggle_1.DormantToggle, null),
        !fixedSessionTypeSelected && react_1.default.createElement(CrowdmapToggle_1.CrowdMapToggle, null),
        !fixedSessionTypeSelected && react_1.default.createElement(YearPicker_1.YearPicker, null)));
};
exports.DesktopSessionFilters = DesktopSessionFilters;
